import React from 'react';
import { Container } from '@hover/blueprint';
import Mobile from './Mobile';
import Desktop from './Desktop';

const AboutSections: React.FC = () => (
  <Container maxW="1200px" pt={600}>
    <Mobile />
    <Desktop />
  </Container>
);

export default AboutSections;
